import { render, staticRenderFns } from "./DepartureGame.vue?vue&type=template&id=44d46f5a&"
import script from "./DepartureGame.vue?vue&type=script&lang=js&"
export * from "./DepartureGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports